module.exports = __webpack_public_path__ + "img/Aarya Pulkundwar.6e8e635e.jpg";